// レジ 支払い完了画面

import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Header from "components/Frame/Header";
import Footer from "components/Frame/Footer";
import Button from "components/button";

/* eslint-disable no-magic-numbers */
const dummy = {
  date:      "2022/12/22 12:00",
  staff:     "TS太郎",
  amount:    1020,
  tax:       93,
  breakdown: [
    // 小計リスト...税率ごとに分類
    { rate: 10, amount: 1020, tax: 93 },
    { rate: 8, amount: 0, tax: 0 }
  ],
  payments: [
    // 支払いリスト...支払い方法ごとに分離
    { name: "現金", amount: 1020 },
    { name: "クレジット", amount: 1020 }
  ],
  change: 0
};
/* eslint-enable no-magic-numbers */

const Breakdown = function ({
  label = "",
  value = 0,
  className = "",
  ...rest
}) {
  return (
    <div className={[className, "clearfix"].join(" ")} {...rest}>
      {label}
      <span className="float-right text-right">
        &yen;<span>{value.toLocaleString("ja-JP")}</span>
      </span>
    </div>
  );
};

const CancelModal = function ({ show, handleClose, passcode }) {
  const [unlocked = false, setUnlocked] = useState();
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header className="color-bg-alert color-text-clear">
        <Modal.Title>会計取消</Modal.Title>
        <button
          type="button"
          className="material-symbols-rounded bg-transparent border-0 color-text-clear"
          aria-label="Close"
          onClick={handleClose}
        >
          close
        </button>
      </Modal.Header>
      <Modal.Body>
        <p>
          この会計に関する情報をすべて取り消し会計前の状態に戻ります。
          <br />
          実行後、元に戻すことはできません。
        </p>
        <Form>
          {/* <div className="form-check">
            <label className="form-check-label">
              <input type="checkbox" className="form-check-input" />
              <span className="small olor-text-secondary">確認しました</span>
            </label>
          </div> */}
          <div>
            <div className="small color-text-secondary">
              会計金額を入力してください
              <span className="color-text-alert fw-bold">({passcode})</span>
            </div>
            <div className="row">
              <div className="col-12 col-md-4">
                <InputGroup>
                  <Form.Control
                    type="text"
                    placeholder={passcode}
                    className="text-right"
                    onChange={(event) =>
                      setUnlocked(event.target.value === String(passcode))
                    }
                  />
                  <InputGroup.Text>円</InputGroup.Text>
                </InputGroup>
              </div>
            </div>
          </div>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          bg="alert"
          border="alert"
          text="clear"
          onClick={handleClose}
          disabled={!unlocked}
        >
          実行
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

// お支払い画面
const View = function ({ data }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <div className="page">
      <CancelModal
        show={show}
        handleClose={handleClose}
        passcode={data.amount}
      ></CancelModal>
      <Header>支払完了</Header>
      <div className="container-fluid py-2">
        <div className="btn-toolbar text-right">
          <Button
            border="alert"
            bg="clear"
            text="alert"
            className="ms-auto"
            onClick={handleShow}
          >
            会計取消
          </Button>
        </div>
      </div>
      <div className="container-fluid">
        <div className="card">
          <div className="card-body color-bg-secondary-light">
            <div className="container-fluid" style={{ maxWidth: "800px" }}>
              <div className="row mb-5">
                <div className="col-5">
                  <div>{data.date}</div>
                  <div>
                    担当:
                    <span className="ms-2">{data.staff}</span>
                  </div>
                </div>
                <div className="col-7">
                  <div
                    className="pe-2 fw-bold mb-3"
                    style={{ fontSize: "2rem" }}
                  >
                    <Breakdown label="合計" value={data.amount}></Breakdown>
                  </div>
                  <div className="ps-5">
                    <Breakdown label="内消費税" value={data.tax}></Breakdown>
                  </div>
                  {data.breakdown.map((d, i) => {
                    return (
                      <div key={`berakdown-${i}`} className="ps-5">
                        <Breakdown
                          label={`${d.rate}%合計`}
                          value={d.amount}
                        ></Breakdown>
                        <Breakdown
                          label={`${d.rate}%内消費税`}
                          value={d.tax}
                        ></Breakdown>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="row mb-3">
                {data.payments.map((payment, i) => (
                  <div
                    key={`payment-${i}`}
                    className="col-12 col-md-6 offset-md-6"
                  >
                    <div className="border-top color-border-primary py-2">
                      <div
                        className="mx-auto clearfix fw-bold"
                        style={{ width: "18rem", fontSize: "1.2rem" }}
                      >
                        <span>{payment.name}</span>
                        <span className="float-right">
                          &yen;{payment.amount.toLocaleString("ja-JP")}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-12 col-md-6 offset-md-6">
                  <div className="border-top color-border-primary py-2">
                    <div
                      className="mx-auto clearfix fw-bold"
                      style={{ width: "18rem", fontSize: "1.5rem" }}
                    >
                      <span>お釣り</span>
                      <span className="float-right">
                        &yen;{data.change.toLocaleString("ja-JP")}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-md-4 mt-2">
                  <Button
                    border="positive"
                    bg="positive"
                    text="clear"
                    className="w-100"
                  >
                    レシート再発行
                  </Button>
                </div>
                <div className="col-12 col-md-4 mt-2">
                  <Button
                    border="positive"
                    bg="positive"
                    text="clear"
                    className="w-100"
                  >
                    電子レシート発行
                  </Button>
                </div>
                <div className="col-12 col-md-4 mt-2">
                  <Button
                    border="positive"
                    bg="positive"
                    text="clear"
                    className="w-100"
                  >
                    領収書発行
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer>
        <div className="text-center">
          <Button border="primary" bg="primary" text="clear" className="w-75">
            領収書発行
          </Button>
          {/* <Button border="negative" bg="negative" text="clear" className="w-75">
            次の会計へ
          </Button> */}
        </div>
      </Footer>
    </div>
  );
};

const Page = function () {
  return <View data={dummy}></View>;
};

export default Page;
